import { render, staticRenderFns } from "./FipeAnoSelect.vue?vue&type=template&id=3cc67243&"
import script from "./FipeAnoSelect.vue?vue&type=script&lang=js&"
export * from "./FipeAnoSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports